import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Dashboard from "./pages/Dashboard/Dashboard";
import ModulesListPage from "./pages/ModulesListPage/ModulesListPage";
import CreateAssignmentPage from "./pages/CreateAssignmentPage/CreateAssignmentPage";
import { Login } from "./pages/Login/Login";
import { ForgotPassword } from "./pages/ForgotPassword/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword/ResetPassword";
import AssignmentPage from "./pages/AssignmentPage/AssignmentPage";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import SignUpPage from "./pages/SignUpPage/SignUpPage";
import StartTrialPage from "./pages/StartTrialPage/StartTrialPage";
import { UserProvider } from "./context/UserContext";
import PrivateRoutesWrapper from "./components/PrivateRoutesWrapper/PrivateRoutesWrapper";
import CompleteSignUpPage from "./pages/CompleteSignUpPage/CompleteSignUpPage";
import SubmissionPage from "./pages/SubmissionPage/SubmissionPage";
import PracticePage from "./pages/PracticePage/PracticePage";
import ReviewPage from "./pages/ReviewPage/ReviewPage";
import ModuleStatsPage from "./pages/ModuleStatsPage/ModuleStatsPage";
import StatsPage from "./pages/StatsPage/StatsPage";
import MarketingRedirect from "./pages/MarketingRedirect";
import AccessExpiredNavigationRegistrar from "./components/AccessExpiredNavigationRegistrar/AccessExpiredNavigationRegistrar";

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
  "pk_test_51LcYZVKnX4kIIuqmPoilSwJTpuxPtO7Q0QjDGCVESgvGACXADXorZjIrXzS9FyXsrIcY8OAV2NJJI5pNcTthiWky00YbK8InCL",
);

function App() {
  return (
    <UserProvider>
      <Elements stripe={stripePromise}>
        <div className="App">
          <AccessExpiredNavigationRegistrar />
          <Routes>
            <Route element={<PrivateRoutesWrapper />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/subjects/:subjectId" element={<ModulesListPage />} />
              <Route
                path="/create-assignment"
                element={<CreateAssignmentPage />}
              />
              <Route path="/assignment" element={<AssignmentPage />} />
              <Route path="/practice" element={<PracticePage />} />
              <Route path="/submissions/:submissionId" element={<SubmissionPage />} />
              <Route path="/review" element={<ReviewPage />} />
              <Route path="/module-stats" element={<ModuleStatsPage />} />
              <Route path="/stats" element={<StatsPage />} />
              {/* Redirected to the dashboard upgrade modal by PrivateRoutesWrapper */}
              <Route path="/access-expired" element={null} />
              <Route path="/upgrade" element={null} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/sign-up" element={<SignUpPage />} />
            <Route path="/start-trial" element={<StartTrialPage />} />
            <Route path="/complete-sign-up" element={<CompleteSignUpPage />} />
            <Route path="*" element={<MarketingRedirect />} />
          </Routes>
        </div>
      </Elements>
    </UserProvider>
  );
}

export default App;
